var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.799 19.523L.048 10.856l-.001-.4 1-1 .402-.001 5.482 5.43 1.082 1.22L7.976.975l.3-.3L9.632.672l.302.299.037 15.13 1.075-1.227 5.456-5.455.401-.001 1.006.996.001.4L9.2 19.521l-.401.001z",
    fill: "current"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTggMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik04Ljc5ODgzIDE5LjUyMzRMMC4wNDc4MDQ0IDEwLjg1NjNMMC4wNDY4NDEyIDEwLjQ1NjlMMS4wNDc4OSA5LjQ1NTgzTDEuNDQ5MjggOS40NTQ4Nkw2LjkzMTI0IDE0Ljg4NDJMOC4wMTI5IDE2LjEwNUw3Ljk3NjQ1IDAuOTc1NjYxTDguMjc2NzYgMC42NzUzNDVMOS42MzE0MyAwLjY3MjA4MUw5LjkzMzE5IDAuOTcwOTQ2TDkuOTY5NjUgMTYuMTAwM0wxMS4wNDU0IDE0Ljg3NDNMMTYuNTAxMiA5LjQxODU5TDE2LjkwMjUgOS40MTc2M0wxNy45MDg0IDEwLjQxMzhMMTcuOTA5NCAxMC44MTMzTDkuMjAwMjEgMTkuNTIyNEw4Ljc5ODgzIDE5LjUyMzRaIiBmaWxsPSJjdXJyZW50IiAvPgo8L3N2Zz4K";
export { SvgArrowLight as ReactComponent };